<template>
  <div class="wrapper">
    <Modal width="750" class="video-wrapper" @on-cancel="cancelWatch" v-model="watchModal" title="课程观看">
      <div slot="header">
        <div style="color: #fff">课程观看</div>
      </div>
      <courseVideo :row="row" ref="courseVideo" @cancelWatch="cancelWatch" />
      <div slot="footer">
        <!-- <Button @click="deleteCourse">删除</Button>
        <Button type="primary" @click="addCourse">添加</Button> -->
      </div>
    </Modal>

    <Modal width="750" class="detail-wrapper" ok-text="" v-model="seeModal" title="课程列表">
      <Table :columns="tableColumns" :data="seeDetailList" border style="margin-top: 20px">
        <template slot-scope="{ row }" slot="is_display">
          {{ row.is_display == 2 ? "是" : "否" }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="info" size="small" @click="watchVideo(row)">播放</Button>
          <!-- <Poptip
          v-auth="'admin/delete'"
          transfer
          confirm
          title="您确定要删除这条数据吗？"
          @on-ok="removes(row)"
          style="margin-left: 5px"
        >
          <Button type="error" size="small">删除</Button>
        </Poptip> -->
        </template>
      </Table>
      <Page style="text-align: right; margin-top: 20px" :total="tableData.total" :page-size="tableData.per_page"
        :current="tableData.current_page" show-total @on-change="getDetail2" />
      <div slot="footer">
        <!-- <Button @click="deleteCourse">删除</Button>
        <Button type="primary" @click="addCourse">添加</Button> -->
      </div>
    </Modal>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import courseVideo from "./courseVideo";
  export default {
    computed: {
      ...mapState({
        subjectList(state) {
          return state.global.subjectList;
        },
        curseList(state) {
          return state.global.curseList;
        },
      }),
    },
    data() {
      return {
        row: {},
        isCourseVideoShow: false,
        videoSrc: "", // 资源地址
        imageSrc: "", // 视频封面
        seconed: "", // 播放位置
        seeModal: false,
        watchModal: false,
        seeDetailList: [],
        params: {},
        storage_id: '', //上一个页面传递过来的storage_id/
        // 分页
        tableData: {
          total: 0,
          per_page: 10,
          current_page: 1,
          last_page: 1,
        },
        tableColumns: [
          { title: "ID", key: "id", align: "center", width: 80, fixed: "left" },
          { title: "课程名称", key: "name", align: "center", width: 200, fixed: "left" },
          {
            title: "是否启用",
            slot: "is_display",
            align: "center",
            minWidth: 140,
          },
          {
            title: "科目",
            key: "subject_name",
            align: "center",
            minWidth: 140,
          },
          {
            title: "课程",
            key: "course_name",
            align: "center",
            minWidth: 140,
          },
          {
            title: "操作",
            slot: "action",
            align: "center",
            fixed: "right",
            width: 120,
          },
        ],
      };
    },
    components: {
      courseVideo,
    },
    mounted() {
      window.oncontextmenu = function () { return false; }; //cjp
    },
    methods: {
      watchVideo(row) {
        this.row = row
        console.log(this.row)
        this.seeModal = false;
        this.watchModal = true;
        this.$refs.courseVideo.reFreshControl(true);
      },
      cancelWatch(params) {
        this.seeModal = true;
        this.watchModal = false;
        this.$refs.courseVideo.reFreshControl(false);
      },

      getDetail(params) {
        console.log(params);
        this.params = params;
        this.seeModal = true;
        this.storage_id = params.storage.id; //保存调用页传递过来的id号
        let data = {
          storage_id: params.storage.id,
          id: "",
        };
        this.$axios.get("/app/source_record_class/index", data).then((res) => {
          if (res.code == 1) {
            this.tableData.total = res.data.total //接受page信息
            this.seeDetailList = res.data.data;
          }
        });
      },
      //由于翻页操作，params没有传递过来的参数storage.id，所以单独写一个当前vue页面的翻页操作，修改以前的没有翻页的bug
      getDetail2(params) {
        console.log('默认参数', params);
        this.params = params;
        this.seeModal = true;
        let data = {
          storage_id: this.storage_id,
          page: params,
        };
        console.log('参数：', data)
        this.$axios.get("/app/source_record_class/index", data).then((res) => {
          if (res.code == 1) {
            this.tableData.total = res.data.total
            this.seeDetailList = res.data.data;
          }
        });
      },

      // 删除课程
      deleteCourse() {
        this.$parent.deleteCourse(this.params);
      },
      // 添加课程
      addCourse() {
        this.$parent.addCourse(this.params);
      },
    },
  };
</script>
<style scoped lang="less">
  /deep/ .ivu-modal {
    width: 80% !important;
  }
  .video-wrapper /deep/ .ivu-modal-content {
    background: rgba(0, 0, 0, 0.7);
  }
  .video-wrapper {
    color: #fff;
  }
</style>
